<template>
  <div style="padding: 20px;background-color: #ffffff;">
    <el-tabs v-model="activeName">
      <el-tab-pane label="导入报名退款订单" name="refundCheck">
        <refund-import/>
      </el-tab-pane>
      <el-tab-pane label="线上报名退款订单" name="importCheck">
        <refund-online :activeName="activeName"/>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import RefundImport from './refundComponents/refund-import'
import RefundOnline from './refundComponents/refund-online'

export default {
  name: 'refund-manage',
  components: { RefundImport, RefundOnline },
  props: [],
  data () {
    return {
      activeName: 'refundCheck'
    }
  },
  async created () {
  },
  async mounted () {
  },
  async beforeDestroy () {
  },
  computed: {},
  watch: {},
  methods: {
    // handleClick (tab, event) {

    // }
  }
}
</script>
